module.exports = __webpack_public_path__ + "img/cities.58d8be13.png";